<template>
  <div class="card h-100 px-3 py-2">
    <div v-if="!!block && !!block.text" v-html="block.text"></div>
    <b-table
      :id="id"
      ref="table"
      class="bg-white table-no-top-border"
      small
      responsive
      show-empty
      :fields="fields"
      :items="players"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template v-slot:empty>
        <h4 v-if="busy" align="center">
          <i class="fa fa-circle-notch fa-spin"></i>
          {{ trans('loading') }}
        </h4>
        <p v-if="!busy && !error" align="center">{{ trans('none') }}</p>
        <p v-if="error" class="text-danger" align="center">
          {{ error }}
        </p>
      </template>
      <template v-slot:cell(team_name)="data">
        <img v-if="!!data.item.team_image_url" :src="data.item.team_image_url" style="max-height: 40px;" />
        <span v-if="!data.item.team_image_url" class="h3"><i class="fa fa-fw fa-tshirt text-muted"></i></span>
        <span class="d-none d-md-inline">{{ data.item.team_name }}</span>
        <small class="d-md-none d-block">{{ data.item.team_name }}</small>
      </template>
    </b-table>
    <b-pagination
      :per-page="perPage"
      :total-rows="!!players ? players.length : 0"
      v-model="currentPage"
      :aria-controls="id"
      size="sm"
      align="center"
    ></b-pagination>
    <div v-if="!!block && !!block.text2" v-html="block.text2"></div>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      isPreview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        lang: lang,
        currency: _.currency,
        busy: false,
        error: null,
        players: null,
        perPage: 10,
        currentPage: 1,
      }
    },
    computed: {
      id() {
        return 'teams-player-stats-' + (!!this.block ? this.block.id : 'undefined')
      },
      fields() {
        return _.compact([
          {key: 'team_name', label: trans('team'), sortable: true},
          {key: 'name', label: trans('player'), sortable: true},
          !!this.block && this.block.meta.show_goals ? {key: 'goals', label: trans('game_goals'), sortable: true} : false,
          !!this.block && this.block.meta.show_assists ? {key: 'assists', label: trans('game_assists'), sortable: true} : false,
          !!this.block && this.block.meta.show_points ? {key: 'points', label: trans('game_points'), sortable: true} : false,
          !!this.block && this.block.meta.show_yellow_cards ? {key: 'yellow_cards', label: trans('yellow'), sortable: true} : false,
          !!this.block && this.block.meta.show_red_cards ? {key: 'red_cards', label: trans('red'), sortable: true} : false,
          !!this.block && this.block.meta.show_penalty_minutes ? {key: 'game_penalty_minutes', label: trans('game_penalty_minutes'), sortable: true} : false,
        ])
      },
    },
    watch: {
      block() {
        this.fetch()
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        if (this.isPreview) {
          let url = `/organization/${this.organization.id}/page/${this.page.id}/simulate_player_stats`
          axios.post(url, this.block)
          .then(response => {
            this.busy = false
            this.players = response.data
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        } else {
          let slug = (this.page.slug || '').replace('/', '') || 'undefined'
          let url = `/org/${this.organization.id}/page/${this.page.upid}/${slug}/teams/${this.block.id}/player_stats`
          axios.get(url)
          .then(response => {
            this.busy = false
            this.players = response.data
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        }
      },
    },
    mounted() {
      window['pagePlayerStats'+(!!this.block ? this.block.id || '' : '')] = this
      this.fetch()
    },
  }
</script>